import { ExprUtils } from '@/common/utils/ExprUtils';
import { MatchedDirSaleLines } from '@/sc/entities/dirSaleLine/MatchedDirSaleLines';
import { useMemo } from 'react';

/**
 * The Direct Sale Lines matched to a Program Product. A Program Product accumulates matches across
 * every Customer and every period, so the match lookup is scoped up front.
 */
export const ProgProdSaleLineList = ({ progProdId, custId, startDate, endDate }) => {
  const matchExpr = useMemo(
    () =>
      ExprUtils.and(
        ExprUtils.is('progProdId', progProdId),
        custId ? ExprUtils.is('custId', custId) : null,
        // earnedDate is the Line's invoice date, so it is what the period boundaries apply to
        ExprUtils.effectiveDateClause('earnedDate', startDate, endDate),
      ),
    [progProdId, custId, startDate, endDate],
  );

  return <MatchedDirSaleLines matchExpr={matchExpr} />;
};
